module.exports = __webpack_public_path__ + "media/images/menu/m2-dd607abddbd46fe73ea2685d51304f05.JPG";